<template>
  <b-container>
    <div id="control-header" style="padding: 10px; font-size: large; font-weight: bold">Gas Data</div>
    <b-button size="sm" @click="requestDownload()" v-if="admin">
      Export Gas Data
    </b-button>
    <ag-grid-vue style="width: 100%; height: 400px"
                 class="ag-theme-balham"
                 :columnDefs="columnDefs"
                 :rowData="rowData"
                 :defaultColDef="defaultColDef"
    >
    </ag-grid-vue>
  </b-container>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import {FileUtils} from "@/lib/FileUtils";
import {
  isAdmin,
  isAdminClass,
  isAdminOrCertifier,
  isAdminVineyardAdminOrCertifier,
  isCertifier,
  isNonCertifierAdmin,
  isPureAdmin,
  isVineyardAdmin,
  isVineyardAdminMeth
} from "@/lib/UserUtils";

const PROPANE_METER = "propane";
const GAS_METER = "naturalGas";
const GASOLINE_METER = "gasoline";
const DIESEL_METER = "diesel";

const SizeEnum = {
  EM1: GAS_METER,
  EM2: PROPANE_METER
};

window.numberParser = function numberParser(params) {
  let parsedNumber = Number(params.newValue);
  return isNaN(parsedNumber) ? "ERROR" : parsedNumber;
};

export default {
  name: "VineyardSimpleGasMetricTable",
  props: {groupId: String},
  components: {
    AgGridVue
  },

  data() {
    return {
      columnDefs: null,
      defaultColDef: null,
      rowData: [],
      bottomData: [],
      rowStyle: {fontWeight: 'bold'},
      myGroupId: this.groupId,
      admin: isAdmin()
    }
  },
  beforeMount() {

    this.columnDefs = [
      {
        headerName: 'Month',
        field: 'meterUsage'
      },
      {
        headerName: 'Natural Gas (Therms)',
        field: GAS_METER,
        valueParser: numberParser
      },
      {
        headerName: 'Propane (Gallons)',
        field: PROPANE_METER,
        valueParser: numberParser
      },
      {
        headerName: 'Gasoline (Gallons)',
        field: GASOLINE_METER,
        valueParser: numberParser
      },
      {
        headerName: 'Diesel (Gallons)',
        field: DIESEL_METER,
        valueParser: numberParser
      }
    ];

    this.defaultColDef = {
      editable: false,
      resizable: true
    };

    let theGroup = this.myGroupId;
    this.$http.get("metrics/vineyard/gas/graph/" + theGroup)
        .then(resultGas => {
          let self = this;
          self.rowData = resultGas.data;
        }).catch(
        error => {
          console.log(error)
        });
    console.log("Gas Row Data in VineyardSimpleGasMetricTable is above.")


  },
  methods: {
    requestDownload() {
      let self = this;
      this.$http.get(`metrics/download/${self.myGroupId}/gas/vineyard`, {responseType: "blob"})
          .then(async response => {
            FileUtils.saveExcelToDisk(response);
          });
    },
  }
}

function getCharCodeFromEvent(event) {
  event = event || window.event;
  return typeof event.which === "undefined" ? event.keyCode : event.which;
}

function isCharNumeric(charStr) {
  return !!/\d/.test(charStr);
}

function isKeyPressedNumeric(event) {
  let charCode = getCharCodeFromEvent(event);
  let charStr = String.fromCharCode(charCode);
  return isCharNumeric(charStr);
}
</script>

<style scoped>

</style>
